import React from 'react';
import { observer } from 'src/utils/mobx-react';
import classNames from 'classnames';
import { Resource } from 'src_common/common/mobx-utils/Resource';
import { OpenapiProxyStaffAllTransactionsGetListResponse200Type } from 'src/api_openapi/generated/openapi_proxy_staff_all_transactions_get_list';
import { useAppStateContext } from 'src/AppState/AppState';
import { getCurrency } from 'src/AppState/sdk/staff';
import { Amount } from 'src_common/common/amount/Amount';
import { DateTime } from 'src_common/utils/time/time';

type DepositHistoryPropsType = {
    withdrawalsList: Resource<OpenapiProxyStaffAllTransactionsGetListResponse200Type>;
    cancelWithdrawal: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => Promise<void>;
    rejectWithdrawal: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => Promise<void>;
};

const formatCardDetails = (cardNumber: string | undefined | null, expires: string | undefined | null): string => {
    const card = cardNumber ?? null;
    const cardExpires = expires ?? null;

    if (card === null) {
        return '-';
    }

    if (cardExpires === null) {
        return card;
    }

    const formatedCardExpires = DateTime.from(cardExpires)?.format('MM/YY');
    if (formatedCardExpires === undefined) {
        return card;
    }

    return `${card}, ${formatedCardExpires}`;
};

export const PendingWithdrawals = observer(
    'PendingWithdrawals',
    ({ withdrawalsList, cancelWithdrawal, rejectWithdrawal }: DepositHistoryPropsType) => {
        const { userLoginState } = useAppStateContext();
        const withdrawals = withdrawalsList.get();

        return (
            <table>
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Amount</th>
                        <th>Payment details</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {withdrawals.type === 'ready'
                        ? withdrawals.value.results
                              .filter(({ status }) => status !== 'failed')
                              .map(({ amount, id, currency, type, createdAt, details }) => {
                                  const convertedAmmout =
                                      type === 'withdrawal' ? new Amount(amount).multiply(-1) : new Amount(amount);

                                  return (
                                      <tr
                                          key={id}
                                          data-test='pending-withdrawal-row'
                                      >
                                          <td data-test='pending-withdrawal-date'>
                                              {DateTime.from(createdAt)?.format('YYYY-MM-DD') ?? '-'}
                                          </td>
                                          <td
                                              className={classNames({
                                                  'amount--negative': convertedAmmout.isLessThanZero,
                                              })}
                                              data-test='pending-withdrawal-amount'
                                          >
                                              {convertedAmmout.format(getCurrency(currency))}
                                          </td>
                                          <td data-test='pending-withdrawal-card-details'>
                                              {formatCardDetails(
                                                  details.paymentMethod?.name,
                                                  details.paymentMethod?.expires
                                              )}
                                          </td>
                                          <td data-test='pending-withdrawal-status'>
                                              <a
                                                  href='#'
                                                  data-test='cancel-withdrawal-button'
                                                  className='withdrawal__cancel'
                                                  data-id={id}
                                                  data-method-type={details.paymentMethod?.type}
                                                  data-provider-reference={details.paymentMethod?.providerReference}
                                                  onClick={cancelWithdrawal}
                                              >
                                                  Cancel
                                              </a>

                                              {details.assignee?.id === userLoginState.userId ? (
                                                  <a
                                                      href='#'
                                                      data-test='reject-withdrawal-button'
                                                      data-id={id}
                                                      data-method-type={details.paymentMethod?.type}
                                                      data-provider-reference={details.paymentMethod?.providerReference}
                                                      onClick={rejectWithdrawal}
                                                  >
                                                      Reject
                                                  </a>
                                              ) : null}
                                          </td>
                                      </tr>
                                  );
                              })
                        : null}
                </tbody>
            </table>
        );
    }
);
